<script lang="ts" setup>
import { computed } from 'vue';

import type { VRouterTab } from '@components/tabs/VRouterTabs/types';
import VCard from '@components/card/VCard/VCard.vue';
import VRouterTabs from '@components/tabs/VRouterTabs/VRouterTabs.vue';
import { useI18n } from '@modules/i18n/composables';
import { TRANSLATION_PLAYER_BONUS_CREATE } from '@modules/players-bonuses/submodules/create/constants';
import {
  PLAYERS_BONUS_CREATE_FILE_ROUTE_NAME,
} from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/constants';
import {
  PLAYERS_BONUS_CREATE_MANUALLY_ROUTE_NAME,
} from '@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/constants';

const { getTranslation } = useI18n();

const tabItems = computed<VRouterTab[]>(() => [
  {
    label: getTranslation(TRANSLATION_PLAYER_BONUS_CREATE, 'TAB_NAME_MANUALLY').value,
    route: {
      name: PLAYERS_BONUS_CREATE_MANUALLY_ROUTE_NAME,
    },
  },
  {
    label: getTranslation(TRANSLATION_PLAYER_BONUS_CREATE, 'TAB_NAME_FILE').value,
    route: {
      name: PLAYERS_BONUS_CREATE_FILE_ROUTE_NAME,
    },
  },
]);
</script>

<template>
  <VCard v-data-qa-auto-id="'PlayersBonusesCreatePage'"
    :title="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE, 'HEADER')"
    type="form"
  >
    <VRouterTabs
      :items="tabItems"
      class="mb-10"
      replace
    />
    <RouterView />
  </VCard>
</template>
